import { useEffect, useRef, useState } from "react";
import { ViewBoardsIcon } from "@heroicons/react/outline";

const ColumnChooser = ({ columns, visibleIds, onToggle, onReset }) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === "Escape") {
        e.stopPropagation();
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey, true);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey, true);
    };
  }, [open]);

  return (
    <div className="ds-popover-root" ref={rootRef}>
      <button
        type="button"
        className="ds-btn ds-btn--ghost"
        aria-haspopup="true"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        title="Επιλογή στηλών"
      >
        <ViewBoardsIcon aria-hidden="true" />
        Στήλες
      </button>
      {open && (
        <div className="ds-popover ds-popover--right" role="dialog" aria-label="Στήλες πίνακα">
          <div className="ds-popover-title">Εμφανιζόμενες στήλες</div>
          <ul className="ds-checklist">
            {columns.map((col) => (
              <li key={col.id}>
                <label>
                  <input
                    type="checkbox"
                    checked={visibleIds.includes(col.id)}
                    onChange={() => onToggle(col.id)}
                    disabled={visibleIds.length === 1 && visibleIds.includes(col.id)}
                  />
                  {col.label}
                </label>
              </li>
            ))}
          </ul>
          <button type="button" className="ds-link-btn" onClick={onReset}>
            Επαναφορά
          </button>
        </div>
      )}
    </div>
  );
};

export default ColumnChooser;
